// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

module.exports = {
	//token
	LOGIN_STATUS: 'LOGIN_STATUS_TOKEN',
	//uid
	UID:'UID',
	//用户信息
	USER_INFO: 'USER_INFO',
	//token过期时间
	EXPIRES_TIME: 'EXPIRES_TIME',
	//微信登录
	WX_AUTH: 'WX_AUTH',
	//公众号登录code
	STATE_KEY: 'wx_authorize_state',
	//登录类型
	LOGINTYPE: 'loginType',
	//登录跳转地址
	BACK_URL: 'login_back_url',
	//小程序登录状态code
	STATE_R_KEY: 'roution_authorize_state',
	//logo 地址
	LOGO_URL: 'LOGO_URL',
	//模板缓存
	SUBSCRIBE_MESSAGE: 'SUBSCRIBE_MESSAGE',

	TIPS_KEY: 'TIPS_KEY',

	SPREAD: 'spread',
	//缓存经度
	CACHE_LONGITUDE: 'LONGITUDE',
	//缓存纬度
	CACHE_LATITUDE: 'LATITUDE',
}
